module.exports = __webpack_public_path__ + "static/media/background.ec8f9995.png";